import axios from 'axios'

/**
 * @desc Fetches All Trading Stores
 */
export const fetchAllRetailerStores = () =>
  axios.get('/authenticated/stores').then((res) => res.data)
